module.exports = __webpack_public_path__ + "assets/icon-animalType-boar.4043de21.svg";